module.exports = __webpack_public_path__ + "static/media/p4_5.bef8cfe8.png";